import api from './axiosConfig';

export const getAboutApi = () => {
  return api.get('/about');
};